import { type MouseEvent, useState } from 'react';

import MailIcon from '@mui/icons-material/Mail';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { IconButton, MenuItem, MenuList, Popover, Stack, Tooltip } from '@mui/material';

const HelpMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleHelpClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleHelpClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title="Help" arrow placement="bottom">
        <IconButton
          aria-label="Help"
          onClick={handleHelpClick}
          color="inherit"
          aria-controls={open ? 'help-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          sx={{
            color: '#fff',
            '&:hover': {
              backgroundColor: 'transparent',
              boxShadow: 'none',
            },
          }}
        >
          <QuestionMarkIcon />
        </IconButton>
      </Tooltip>

      <Popover
        anchorEl={anchorEl}
        open={open}
        onClose={handleHelpClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        slotProps={{
          root: { id: 'help-menu' },
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
      >
        <MenuList>
          <MenuItem
            onClick={handleHelpClose}
            href="mailto:helpdesk@morganlewis.com?subject=IG%20Portal%20Support%20Request"
            component="a"
          >
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center', flexWrap: 'nowrap' }}>
              <MailIcon />
              <span>Support</span>
            </Stack>
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  );
};

export default HelpMenu;
